var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoWeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.85 11.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ecb3a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico web") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.93,0a5.92,5.92,0,1,0,5.92,5.92A5.93,5.93,0,0,0,5.93,0M11,5.52H8.79a8.65,8.65,0,0,0-1.14-4.4A5.12,5.12,0,0,1,11,5.52M5.93,11c-.93,0-2-1.91-2-4.7H8c-.09,2.79-1.12,4.7-2,4.7m-2-5.52C4,2.73,5,.82,5.93.82s1.95,1.91,2,4.7Zm.33-4.4a8.64,8.64,0,0,0-1.15,4.4H.84a5.12,5.12,0,0,1,3.37-4.4M.84,6.33H3.06a8.64,8.64,0,0,0,1.15,4.4A5.12,5.12,0,0,1,.84,6.33m6.81,4.4a8.64,8.64,0,0,0,1.14-4.4H11a5.12,5.12,0,0,1-3.37,4.4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWeb);
export default __webpack_public_path__ + "static/media/ico-web.03e5b6273132ae7396d2bb669f89147d.svg";
export { ForwardRef as ReactComponent };